import React, { useEffect } from "react";
import Brand from "../../assets/images/logo.png";
import BrandIcon from "../../assets/images/logoIcon.svg";
import { Link } from "react-router-dom";
import { Col, Dropdown, Row } from "react-bootstrap";

import avatar from "../../assets/images/avatar.png";
import { Icon } from "@iconify/react";
import { logout } from "../../redux/authSlice";
import { useDispatch } from "react-redux";
import authSvc from "../../services/auth-service";
import { filter, skip } from "rxjs";
import SearchField from "./SearchField";
import { pascalCase } from "pascal-case";
import { resetState, resetSurvey } from "../../redux/surveySlice";

const Header = ({ text, onChange }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useDispatch();
  useEffect(() => {
    const subscription = authSvc.loginObservable$
      .pipe(
        skip(1),
        filter((isLoggedIn) => !isLoggedIn)
      )
      .subscribe(() => logoutUser());

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const logoutUser = () => {
    localStorage.clear();
    dispatch(resetState());
    dispatch(logout());
  };
  return (
    <div className="headerMain">
      <Row className="align-items-center">
        <Col sm="3" xs="6">
          <img
            height="35"
            src={Brand}
            alt=""
            className="d-none d-md-inline-block"
          />
          <img
            height="35"
            src={Brand}
            alt=""
            className="d-inline-block d-md-none"
          />
        </Col>
        <Col sm="6" className="d-md-block d-none">
          {/* <ul className="topMenu">
            <li>
              <Link to="#" className="active">
                Home
              </Link>
            </li>
            <li>
              <Link to="#">Reports</Link>
            </li>
            <li>
              <Link to="#">About</Link>
            </li>
          </ul> */}
        </Col>
        <Col sm="3" xs="6">
          <ul className="topRightLinks d-none d-md-flex">
            {/* <li>
              <Link to="#" className="notify">
                <Icon icon="lucide:bell" /> <span></span>
              </Link>
            </li> */}
            <li className="dropdownUser">
              <Dropdown>
                <Dropdown.Toggle variant="avatar" id="dropdown-basic">
                  {/* <img src={avatar} alt="" /> */}
                  {user?.firstName.charAt(0).toUpperCase() +
                    user?.lastName.charAt(0).toUpperCase()}
                </Dropdown.Toggle>
                <Dropdown.Menu show>
                  <Dropdown.Item className="avatarMenu">
                    <div className="avImg">
                      {user?.firstName.charAt(0).toUpperCase() +
                        user?.lastName.charAt(0).toUpperCase()}
                    </div>

                    <div className="fullName">
                      {user?.firstName.toUpperCase() +
                        " " +
                        user?.lastName.toUpperCase()}
                    </div>
                    <div className="userType">
                      {pascalCase(user?.role || "surveyor")}{" "}
                    </div>
                  </Dropdown.Item>
                  <hr />
                  <Dropdown.Item
                    onClick={() => logoutUser()}
                    href="#"
                    className="logOut"
                  >
                    <i>
                      <Icon icon="tabler:logout" />
                    </i>{" "}
                    <span>Logout</span>{" "}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
          </ul>
        </Col>
        <Col xs="12" className="d-block d-md-none">
          <SearchField text={text} onChange={onChange} />
        </Col>
      </Row>
    </div>
  );
};

export default Header;
